import React, { useState } from "react";
import DataInput from "./DataInput";

import { ReactComponent as ArrowDown } from "../../../assets/images/icon-arrow-down.svg";
import { ReactComponent as ArrowUp } from "../../../assets/images/icon-arrow-up.svg";
import LabeledDropdown from "./LabeledDropdown";
import { capitalize, uppercase } from "../../../utils";

interface ApiInfo {
  moneyhub: string;
  powens: number;
  yodlee: string;
}

interface Category {
  name: string;
  status: string;
  apiProvider: string;
  api: ApiInfo;
}

interface CategoryDetailsCollapseProps {
  category: Category;
  index?: number;
  onCategoryChange: (updatedCategory: Category) => void;
}

const CategoryDetailsCollapse: React.FC<CategoryDetailsCollapseProps> = ({
  category,
  onCategoryChange,
}) => {
  const [showMore, setShowMore] = useState(false);

  const handleUpdate = (field: string, value: string) => {
    const updated = {
      ...category,
      ...(field === "apiProvider"
        ? { [field]: uppercase(value) }
        : field === "status"
        ? { [field]: value }
        : {
            api: {
              ...category.api,
              [field]: value,
            },
          }),
    };
    onCategoryChange(updated);
  };

  return (
    <div
      style={{
        // border: "1px solid #ccc",
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          fontSize: 16,
          cursor: "pointer",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          fontFamily: "Gilroy-Regular",
          //   fontSize: "16px",
        }}
        onClick={() => setShowMore((prev) => !prev)}
      >
        {capitalize(category.name)}
        {showMore ? (
          <ArrowUp width={15} height={15} />
        ) : (
          <ArrowDown width={15} height={15} />
        )}
      </div>

      {showMore && (
        <div style={{ backgroundColor: "#fff", padding: "16px" }}>
          <LabeledDropdown
            label="Status"
            isHorizontal
            options={[
              { key: "1", value: "Active" },
              { key: "2", value: "Inactive" },
            ]}
            initialState={capitalize(category.status)}
            handleSelect={(v) => handleUpdate("status", v as string)}
          />
          <LabeledDropdown
            label="Default API"
            isHorizontal
            options={[
              { key: "1", value: "Moneyhub" },
              { key: "2", value: "Yodlee" },
              { key: "3", value: "Powens" },
            ]}
            initialState={capitalize(category.apiProvider.toLowerCase())}
            handleSelect={(v) => handleUpdate("apiProvider", v as string)}
          />

          <DataInput
            label="Yodlee"
            value={category.api.yodlee}
            isInput
            onChange={(v) => handleUpdate("yodlee", v)}
            isInCollapse
          />
          <DataInput
            label="Moneyhub"
            value={category.api.moneyhub}
            isInput
            onChange={(v) => handleUpdate("moneyhub", v)}
            isInCollapse
          />
          <DataInput
            label="Powens"
            value={String(category.api.powens)}
            isInput
            onChange={(v) => handleUpdate("powens", v)}
            isInCollapse
          />
        </div>
      )}
    </div>
  );
};

export default CategoryDetailsCollapse;
